// IDs are used only for in-memory duplicate suppression, never emitted or persisted.
const seen = new Set();
export function trackSuccess(name, localId) {
  if (!["signup_completed", "interview_started", "interview_completed"].includes(name)) return;
  const key = `${name}:${localId || "current"}`;
  if (seen.has(key)) return;
  seen.add(key);
  if (seen.size > 1000) seen.delete(seen.values().next().value);
  window.dispatchEvent(new CustomEvent("presagio:site-event", { detail: { name, properties: {} } }));
}
